import React, { useEffect } from 'react'
import { Outlet, Navigate,useLocation } from "react-router-dom"
import{ useAuth} from '../hooks/useAuth';

export const  ProtectedRoute=({element:Component,path,...rest})=>{

    const { user,token, logout } = useAuth();
    const location = useLocation();

    const isAuthenticated = user && token;

    useEffect(() => {
        if (!isAuthenticated) logout();
      }, [isAuthenticated, logout]);


    if (!isAuthenticated) {
        return <Navigate to="/signin" replace state={{ from: location }}/>;
    }
    return <Outlet />;
}